import { render, staticRenderFns } from "./empty_notification_component.vue?vue&type=template&id=2e9ba372&"
import script from "./empty_notification_component.vue?vue&type=script&lang=js&"
export * from "./empty_notification_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports